import { DateTime } from 'luxon';

export function convertTimestampsSummaryToRange(timestampsSummary) {
  const { maxEarliestDataTimestamp, minLatestDataTimestamp } =
    timestampsSummary;
  if (!maxEarliestDataTimestamp || !minLatestDataTimestamp) {
    return {
      start: DateTime.now().endOf('day'),
      end: DateTime.now().endOf('day'),
    };
  }

  if (
    DateTime.isDateTime(maxEarliestDataTimestamp) &&
    DateTime.isDateTime(minLatestDataTimestamp)
  ) {
    return {
      start: maxEarliestDataTimestamp,
      end: minLatestDataTimestamp,
    };
  }

  return {
    start: DateTime.fromISO(maxEarliestDataTimestamp),
    end: DateTime.fromISO(minLatestDataTimestamp),
  };
}
export function convertTimestampsSummaryToDateTimes(timestampsSummary) {
  const result = {};
  for (const [key, value] of Object.entries(timestampsSummary)) {
    if (DateTime.isDateTime(value)) {
      return;
    }
    if (value === null || value === undefined) {
      result[key] = value;
    } else {
      result[key] = DateTime.fromISO(value);
    }
  }
  return result;
}

export function isOutOfBounds(timestampsSummary, timeRange) {
  const { start, end } = convertTimestampsSummaryToRange(timestampsSummary);
  const startTooEarly = timeRange.start < start;
  const endTooLate = timeRange.end > end;
  return startTooEarly || endTooLate;
}

export function isCompletelyOutside(timestampsSummary, timeRange) {
  const { start, end } = convertTimestampsSummaryToRange(timestampsSummary);
  return timeRange.start > end || timeRange.end < start;
}

/**
 * Returns a time range with start and end guaranteed to be luxon DateTime objects.
 * @param {Object} timestampsSummary
 * @param {Object} timeRange
 * @returns {{start: DateTime, end: DateTime}}
 */
export function getAdjustedTimeRange(timestampsSummary, timeRange) {
  const { start, end } = convertTimestampsSummaryToRange(timestampsSummary);

  const rangeStart = DateTime.isDateTime(timeRange.start)
    ? timeRange.start
    : DateTime.fromISO(timeRange.start);
  const rangeEnd = DateTime.isDateTime(timeRange.end)
    ? timeRange.end
    : DateTime.fromISO(timeRange.end);

  /** @type {DateTime} */
  const adjustedStart = rangeStart < start ? start : rangeStart;
  /** @type {DateTime} */
  const adjustedEnd = rangeEnd > end ? end : rangeEnd;
  return {
    start: adjustedStart,
    end: adjustedEnd,
  };
}

export function combineTimestampsSummaryList(timestampsSummaryList) {
  //combines the timestampsSummaryList into a single summary
  return timestampsSummaryList.reduce((acc, curr) => {
    return {
      maxEarliestDataTimestamp: acc.maxEarliestDataTimestamp
        ? DateTime.max(
            acc.maxEarliestDataTimestamp,
            curr.maxEarliestDataTimestamp,
          )
        : curr.maxEarliestDataTimestamp,
      minLatestDataTimestamp: acc.minLatestDataTimestamp
        ? DateTime.min(acc.minLatestDataTimestamp, curr.minLatestDataTimestamp)
        : curr.minLatestDataTimestamp,
    };
  }, {});
}

export function isValidTimestampsSummary(timestampsSummary) {
  const { maxEarliestDataTimestamp, minLatestDataTimestamp } =
    timestampsSummary;
  return (
    DateTime.isDateTime(maxEarliestDataTimestamp) &&
    DateTime.isDateTime(minLatestDataTimestamp)
  );
}
